import React from "react";
import { StudentPrivateRoute } from "../services/protectedRoutes";
import StudentDashboard from "../components/Student/DashBoard/DashBoard.js";
import StudentExamPage from "../components/Student/DashBoard/Exam/StudentExamPage.js";

export const StudentRouter = [
  {
    path: "/student/dashboard",
    element: (
      <StudentPrivateRoute>
        <StudentDashboard />
      </StudentPrivateRoute>
    ),
    children: [
    ,
    ],
  },

  {
    path: "/student/dashboard/exam",
    element: (
      <StudentPrivateRoute>
        <StudentExamPage />
      </StudentPrivateRoute>
    ),
  }
];
